export default __webpack_public_path__ + "static/media/thirteen.29110d14.svg";